<template>
  <div id="app">
    <!-- Navigation Bar (Header) -->
    <AppHeader />

    <!-- Main content of the page based on the active route -->
    <router-view id="router"/>

    <!-- Footer -->
    <AppFooter />
  </div>
</template>

<script>
// Import components
import AppHeader from './components/AppHeader.vue';  // Your Header component
import AppFooter from './components/AppFooter.vue';  // Your Footer component

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
  },
};
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Jersey+15&family=Overpass:ital,wght@0,100..900;1,100..900&family=Raleway:ital,wght@0,100..900;1,100..900&display=swap');


/* Global styles for the app can go here */
body {

  margin: 0;
  font-family: Arial, sans-serif;
}

#app {
  font-family: "Overpass", serif;
  font-optical-sizing: auto;
  font-weight: <weight>;
  font-style: normal;
  font-weight: 400;
  font-style: normal;


  display: flex;
  flex-direction: column;
  min-height: 100vh;  /* Ensure the container stretches to full viewport height */
  
  background-image: url('~@/assets/abst3.jpg');
  background-size: cover; /* Ensures the image covers the entire element */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
}

#router {
  flex-grow: 1;  /* This makes the content area take up remaining space */
  
}

/* Styling for the footer */
footer p {
  margin: 0.5rem 0;
}

/* Footer component */
.AppFooter {
  background-color: #333;
  color: white;
  text-align: center;
  padding: 1rem;
  margin-top: auto; /* This ensures the footer stays at the bottom */
}
</style>
